import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PDFUtilities {
    print(iframeElement: HTMLElement) {
        const printFrame = iframeElement as HTMLIFrameElement;
        printFrame.contentWindow.print();
    }
}
